<template lang="pug">
.row.m-0.align-items-center.w-100
  .mr-2.date
    span {{ part1 }}
    span.purple-text.ml-1 {{ part2 }}
  .flex-fill 
  .date.ml-auto(v-if="[49,51].includes(source.sportsId) && source.matchTime") No. {{ part3 }}
</template>


<script>
export default {
  props: {
    source: {
      type: Object
    },
    horiz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countDown: 0,
      ticker: null
    };
  },
  computed: {
    currency_code() {
      return this.$store.getters.currencyCode;
    },
    part2() {
      const dateFmt = "MM/DD";
      const timeFmt = "HH:mm";
      let timeAdjust = 0;

      switch (this.currency_code) {
        case "MMK":
        case "MMO":
          timeAdjust = -90;
          break;
        case "NGN":
          timeAdjust = 420;
          break;
      }

      const mdate = this.mode ? this.$dayjs(this.source.match[8]).subtract(timeAdjust, 'minute').format(dateFmt) : this.$dayjs(this.source.matchTime).subtract(timeAdjust, 'minute').format(dateFmt);
      const mtime = this.mode ? this.$dayjs(this.source.match[8]).subtract(timeAdjust, 'minute').format(timeFmt) : this.$dayjs(this.source.matchTime).subtract(timeAdjust, 'minute').format(timeFmt);

      const mt = this.mode ? this.source.match[4] : this.source.marketId;
      const score = this.mode ? this.source.match[11] : this.source.runningScore;
      const label = this.mode ? this.source.match[12] : this.source.runningTime;

      if (mt < 3) {
        return mtime;
      } else {
        if (label && label.trim().length > 0) {
          return score !== null && score.trim().length > 0 ? score.trim() : mdate;
        } else {
          return mdate;
        }
      }
    },
    part1() {
      const matchTime = this.mode ? this.source.match[8] : this.source.matchTime;
      let timeAdjust = 0;

      switch (this.currency_code) {
        case "MMK":
        case "MMO":
          timeAdjust = -90;
          break;
        case "NGN":
          timeAdjust = 420;
          break;
      }
      
      const date = this.$dayjs(matchTime).subtract(timeAdjust, 'minute').format('MM/DD');
      const time = this.$dayjs(matchTime).subtract(timeAdjust, 'minute').format('HH:mm');
      const label = this.mode ? this.source.match[12] : this.source.runningTime;
      
      return (this.mode && this.source.match[4] < 3) || (!this.mode && this.source.marketId < 3) ? date : (label && label.trim().length > 0 ? this.getLabel(label) : time);
    },
    part3() {
      var mdate = this.$dayjs(this.source.matchTime).format("MMDDhhmm");
      return mdate;
    }
  },
  destroyed() {
  },
  mounted() {  },
  methods: {
    getLabel(e) {
      if (/\d/.test(e)) {
        return e.trim();
      }
        
      return this.$tc("m.BT_" + e.trim(), 1);
    }
  }

}
</script>